import type { INorm } from '@thi.ng/random';
import { SYSTEM } from '@thi.ng/random';
import type { Noise } from '@/types/Noise';

/** Reverb Option */
export type ReverbOptions = {
  /**
   * IR (Impulse Response) waveform table generation color noise algorithm.
   * @see {@link https://github.com/thi-ng/umbrella/tree/develop/packages/colored-noise}
   */
  noise: Noise;
  /** IR source noise scale */
  scale: number;
  /** Number of IR source noise peaks */
  peaks: number;
  /**
   * Random noise algorithm.
   * @see {@link https://github.com/thi-ng/umbrella/tree/develop/packages/random}
   */
  randomAlgorithm: INorm;
  /** Decay */
  decay: number;
  /** Delay until impulse response is generated */
  delay: number;
  /** Filter frequency applied to impulse response[Hz] */
  filterFreq: number;
  /** Filter quality for impulse response */
  filterQ: number;
  /** Filter type for impulse response */
  filterType: BiquadFilterType;
  /** Dry/Wet ratio */
  mix: number;
  /** Reverse the impulse response waveform table */
  reverse: boolean;
  /** Impulse response length */
  time: number;
  /** Prevents multiple effectors from being connected. */
  once: boolean;
};

/** Default Value */
export const ReverbOptions: ReverbOptions = {
  noise: 'white',
  scale: 1,
  peaks: 2,
  randomAlgorithm: SYSTEM,
  decay: 2,
  delay: 0,
  reverse: false,
  time: 2,
  filterType: 'allpass',
  filterFreq: 2200,
  filterQ: 1,
  mix: 0.5,
  once: false,
};
